import Map from 'ol/Map.js';
import View from 'ol/View.js';
import TileLayer from 'ol/layer/Tile.js';
import OSM from 'ol/source/OSM.js';
import Overlay from 'ol/Overlay.js';
import {useGeographic} from 'ol/proj.js';
import {Control, ScaleLine, defaults as defaultControls} from 'ol/control.js';


function showLocationMap() {

    useGeographic();

    var positionWatch, marker;
	
	class Drag extends PointerInteraction {
  constructor() {
    super({
      handleDownEvent: handleDownEvent,
      handleDragEvent: handleDragEvent,
      handleMoveEvent: handleMoveEvent,
      handleUpEvent: handleUpEvent,
    });

    /**
     * @type {import("../src/ol/coordinate.js").Coordinate}
     * @private
     */
    this.coordinate_ = null;

    /**
     * @type {string|undefined}
     * @private
     */
    this.cursor_ = 'pointer';

    /**
     * @type {Feature}
     * @private
     */
    this.feature_ = null;

    /**
     * @type {string|undefined}
     * @private
     */
    this.previousCursor_ = undefined;
  }
}

    class getLocation extends Control {
    constructor(opt_options) {
      const options = opt_options || {};
      const button = document.createElement("button");
      button.innerHTML = "";
      const element = document.createElement("div");
      element.className = "getLocation ol-unselectable ol-control";
      element.appendChild(button);
      super({
        element,
        target: options.target
      });
      button.addEventListener("click", this.doGeolocation.bind(this), false);
    }

        doGeolocation() {
          if (positionWatch) {
            navigator.geolocation.clearWatch(positionWatch);
            map.removeOverlay(marker);
            positionWatch = null;
            document.getElementById("positionNotice").classList = "";
        //	map.updateSize();
            return;
          }
        //document.querySelector(".pswp").append(document.importNode(document.getElementById("positionMarkerTemplate").content, true));
          marker = new Overlay({
            position: [void 0],
            positioning: "center-center",
            element: document.getElementById("positionMarker"),
            stopEvent: false
          });
          map.addOverlay(marker);
        /*     var positionNotice = document.getElementById("positionNotice");
          positionNotice.classList = "shown";*/
          positionWatch = navigator.geolocation.watchPosition(geo_onSuccess, geo_onError, { maximumAge: 0, enableHighAccuracy: true });
          function geo_onSuccess(position) {
            var lat = position.coords.latitude;
            var lon = position.coords.longitude;
        //    var location = transform([lon, lat], "EPSG:4326", "EPSG:2393");
              var location = [lon, lat];
            marker.setPosition(location);
            var viewExtent = map.getView().calculateExtent(map.getSize());


        /*	var target;
            var distance;

            if (activeTarget[0] && activeTarget[1] ) { 
                target = activeTarget;
            } else {
                target = view.getCenter();
            }		  
            var a = location[0] - target[0];
            var b = location[1] - target[1];


            distance = Math.sqrt(a * a + b * b);
            if (distance <= 1e3) {
              distance = Math.round(distance);
              distance += " m";
            } else {
              distance /= 1e3;
              distance = distance.toFixed(1);
              distance += " km";
            }

            var  targetNotice = "kartan keskipisteeseen";
            if (activeTarget[0] && activeTarget[1] ) { 
                targetNotice = "valitsemaasi kohteeseen";
            } 

            positionNotice.innerHTML = "Et\xE4isyytesi " + targetNotice + " on " + distance;
            if (location[0] < viewExtent[0] || location[0] > viewExtent[2] || location[1] < viewExtent[1] || location[1] > viewExtent[3]) {
              positionNotice.innerHTML += "<br>Olet karttan\xE4kym\xE4n ulkopuolella.";
            }

        */    
          }
          function geo_onError(position) {
            alert("Laitteen paikannus ei k\xE4yt\xF6ss\xE4 \u2013 sy\xF6t\xE4 sijaintisi k\xE4sin tai valitse sijainti kartalta!");
            document.getElementById("positionNotice").classList = "shown";
          }
    }





    }




	
	




	
	
	
   var location = [25,63];

    var marker = new Overlay({
        position: [void 0],
        positioning: "center-center",
        element: document.getElementById("positionMarker"),
        stopEvent: true
    });

    
 //   const pointFeature = new Feature(new Point([25, 60]));
    
    const view = new View({

    center: [24.9517, 60.1619],
    zoom: 6,
    enableRotation: false,

    })


    const map = new Map({
    target: 'map_canvas',
    overlays: [],
    controls: defaultControls().extend([
     new mapExit(),
     new getLocation(),
     new ScaleLine({ units: "metric" })
    ]),
    layers: [
        new TileLayer({
          source: new OSM()
        }),
   /*     new VectorLayer({
          source: new VectorSource({
            features: [pointFeature],
          }),
            style: new Style({
                image: new Icon({
                  anchor: [0.5, 1],
                  anchorXUnits: 'fraction',
                  anchorYUnits: 'fraction',
                  opacity: 1,
                    scale: 0.5,
                  src: 'icon.png',
                }),
        }),
    }),
*/
    ],
    view: view
    });
    
   map.addOverlay(marker);
    marker.setPosition(location);
    
    
    map.on('click', function(evt){
       // console.log(JSON.stringify(evt.coordinate));
        marker.setPosition(evt.coordinate);
        //view.setCenter(evt.coordinate);
         view.animate({center: evt.coordinate});
        var lat = evt.coordinate[1];
		var lon = evt.coordinate[0];
		//document.getElementById("custLoc-lat").value = lat.toFixed(4);
		//document.getElementById("custLoc-lon").value = lon.toFixed(4);
    });
	
	 marker.on('handleDownEvent', function(evt){
		  var lat = evt.coordinate[1];
      });
    
    document.getElementById("positionMarker").addEventListener('mousedown', function(evt) {
      function move(evt) {
        marker.setPosition(map.getEventCoordinate(evt));
      }

      function end(evt) {
        window.removeEventListener('mousemove', move);
        window.removeEventListener('mouseup', end);
      }
      window.addEventListener('mousemove', move);
      window.addEventListener('mouseup', end);
    });


  
 /*  const translate = new Translate({
           pointFeature,
        })

        translate.on('translateend', e => {
           // pointFeature.getPosition(e.coordinate);
          //let lonLat = toLonLat(e.coordinate)
        })

        map.addInteraction(translate);*/
}

showLocationMap();
